import React from "react";



export default function QuestionTextInput( props ) {
    return (
        <div>
            <textarea rows="3" name={props.name} disabled={props.disabled} onChange={props.onChange} value={props.value} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-0 focus:border-main"/>
        </div>
    )
}